var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-modal',{ref:"modal",attrs:{"title":"问题预览","width":"90%","height":"90%","show-zoom":"","resize":""},on:{"show":_vm.handleShow},model:{value:(_vm.formVisible),callback:function ($$v) {_vm.formVisible=$$v},expression:"formVisible"}},[_c('div',{staticClass:"readonly-summary-table"},[_c('vxe-grid',{ref:"xTable",attrs:{"resizable":"","data":_vm.modalTableData,"size":"mini","mouse-config":{ area: true },"highlight-hover-row":"","highlight-current-row":"","height":"100%","columns":_vm.readonlyColumns,"cell-style":_vm.cellStyleMethod,"row-config":{ height: 60 },"show-overflow":true,"tooltip-config":{
        showAll: true,
        theme: 'dark'
      },"keyboard-config":{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: false
      },"scroll-y":{
        mode: 'wheel'
      },"clip-config":{
        copyMethod: _vm.copyMethod
      },"show-footer":"","footer-method":_vm.footerMethod},on:{"filter-change":_vm.filterChange,"checkbox-change":function($event){return _vm.$emit('checkbox-change', $event)},"checkbox-all":function($event){return _vm.$emit('checkbox-all', $event)},"cell-click":function($event){return _vm.$emit('cell-click', $event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }